import Vue from 'vue';

export default {
    namespaced: true,
    // -----------------------------------------------------------------
    state: {
        tips: [],
    },
    // -----------------------------------------------------------------
    getters: {
        all: (state) => { return state.tips },
    },
    // -----------------------------------------------------------------
    mutations: {
        SET_TIPS(state, tips) {
            state.tips = tips
        },
        UPDATE_TIPS(state, tip) {
            let index = state.tips.findIndex((t) => t.id === tip.id)

            if (index !== -1) this._vm.$set(state.tips, index, tip)
        },
    },
    // -----------------------------------------------------------------
    actions: {
        readTips: context => {
            if (context.getters.all.length > 0) return

            return Vue.api.get('tips')
                .then(response => {
                    context.commit('SET_TIPS', response.data.data)
                })
                .catch(error => { throw error.response.data.error })
        },
        readUserTips: (context, user_id) => {
            return Vue.api.get(`users/${user_id}/tips`)
                .then(response => {
                    context.commit('SET_TIPS', response.data.data)
                })
                .catch(error => { throw error.response.data.error })
        },
        readTip: (context, id) => {
            return Vue.api.get(`tips/${id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        readUserTip: (context, { user_id, id: id }) => {
            return Vue.api.get(`users/${user_id}/tips/${id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        createTip: (context, data) => {
            return Vue.api.post(`tips`, data)
                .then(response => {
                    context.commit('UPDATE_TIPS', response.data.data)
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        updateTip: (context, data) => {
            let fd = new FormData()
            fd.append('_method', 'PUT')
            fd.append('title', data.title)
            fd.append('content', data.content)
            fd.append('preview', data.preview)
            fd.append('day', data.day)
            fd.append('profession_type_id', data.profession_type_id)

            if (data.clear_audio && Array.isArray(data.clear_audio) && data.clear_audio.length > 0) {
                data.clear_audio.forEach(audioId => {
                    fd.append('clear_audio[]', audioId)
                })
            }

            data.tip_categories.forEach(category => {
                fd.append('tip_categories[]', category)
            })
            data.files.forEach(file => {
                fd.append('image', file.file, file.name)
            })


            data.audio_files.forEach(file => {
                fd.append('audio_files[]', file.file, file.name)
            })

            return Vue.api.post(`tips/${data.id}`, fd)
                .then(response => {
                    context.commit('UPDATE_TIPS', response.data.data)
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        }
    }
}